import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { DepositsWrapper } from "../../components";

export default function DepositsPage() {
  const organization = AuthService.getOrg()?.[0];

  return (
    <ModalProvider>
      <DepositsWrapper organization={organization} />
    </ModalProvider>
  );
}
